import { defineStore } from 'pinia';
import { ref, useNuxtApp, useRouteAnnouncer } from '#imports';

export const useNotificationsStore = defineStore('notifications', () => {
    const nuxtApp = useNuxtApp();
    const notifications = ref([]);

    return {
        notifications,
        addNotification(notification) {
            if (nuxtApp.isHydrating && nuxtApp.payload.serverRendered) return;

            useRouteAnnouncer().set(notification.message);

            notifications.value.unshift({
                ...notification,
                id: notification.id ?? nuxtApp.$dsc.uuidv4(),
                type: notification.type ?? 'success',
            });
        },
    };
});
